






















import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  MarketingCenterColorSchemeDictionary,
  EMarketingCenterColorSchemes
} from '@/models/marketingCenter/colorScheme';

@Component({})
export default class ColorPallete extends Vue {
  @Prop({ default: '' }) value!: EMarketingCenterColorSchemes;

  get Colors() {
    return Object.keys(MarketingCenterColorSchemeDictionary).map(key => ({
      ...MarketingCenterColorSchemeDictionary[
        key as EMarketingCenterColorSchemes
      ],
      key
    }));
  }
}
